import { TileLayer } from 'leaflet';
export const basemapNormalLayer: TileLayer = new TileLayer('https://{s}.wien.gv.at/basemap/geolandbasemap/normal/google3857/{z}/{y}/{x}.png', {
  subdomains: ['mapsneu'],
  attribution: '&copy; Datenquelle: <a href="http://basemap.at">basemap.at</a>'
});